import { getds } from 'ds'
import PlaywireTagged from 'shared-components/ad/PlaywireTagged'
import { useTaglessAd } from 'shared-components/hooks/use-tagless-ad'
import styleUtils from 'shared-components/styles/util.module.css'
import TopicTemplate from 'shared-components/templates/TopicTemplate'
import { DSTopicPage } from 'shared-definitions/types'
import { generateAdPlacementIndex } from 'utility/index'
import styles from './TopicTemplateSG.module.css'

interface TopicTemplateSGProps {
  page: DSTopicPage
}

const generateAdPlacement = (): number =>
  generateAdPlacementIndex('lastTopicIncontentAdPlacement', 0, 1)

const TopicTemplateSG: React.FC<TopicTemplateSGProps> = ({ page }) => {
  useTaglessAd(['bottom_rail', 'corner_ad_video'])

  return (
    <TopicTemplate
      leaderBoards={[
        <PlaywireTagged key={0} type="leaderboard_atf" className={styles.leaderboardFirst} />,
        <PlaywireTagged key={1} type="leaderboard_btf" className={styles.leaderboardSecond} />,
      ]}
      sideBar={<PlaywireTagged className={styleUtils.sidebarEl} type="med_rect_atf" />}
      stickySidebar={true}
      page={page}
      generateIncontentAdPlacementIndex={generateAdPlacement}
      loadTaxonomiedList={async (...args) => {
        const dataSource = await getds()
        const result = await dataSource.getTaxonomiedPostsList(...args)
        return result.data.items
      }}
    />
  )
}

export default TopicTemplateSG
